import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useProfile } from '@brg/auth'
import { useModal } from 'core'
import { CreateLinkTo } from 'shared/constants/linkTo'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from './styles'

export const ChooseAkiStatusSuccessModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()
  const profile = useProfile()

  const handleClose = useCallback(() => {
    modal.hide()
    history.goBack()
  }, [modal, history])

  const handleGoToProfile = useCallback(() => {
    const profileId = profile?.designerId ?? profile?.accountId
    modal.hide()
    if (profileId) {
      history.push(CreateLinkTo.designerNew(profile))
    } else {
      history.goBack()
    }
  }, [modal, history, profile])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.success_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>
        {t('choose_aki_status.modal.success_description')}
      </ModalDescription>
      <ModalActions>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleGoToProfile}>
          {t('choose_aki_status.modal.my_profile')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useProfile } from '@brg/auth'
import { useModal } from 'core'
import { CreateLinkTo } from 'shared/constants/linkTo'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from './styles'

export const ChooseAkiStatusSuccessModal: FC = () => {
  const { t } = useTranslation()
  const modal = useModal()
  const history = useHistory()
  const profile = useProfile()

  const handleClose = useCallback(() => {
    modal.hide()
    history.goBack()
  }, [modal, history])

  const handleGoToProfile = useCallback(() => {
    const profileId = profile?.designerId ?? profile?.accountId
    modal.hide()
    if (profileId) {
      history.push(CreateLinkTo.designerNew(profile))
    } else {
      history.goBack()
    }
  }, [modal, history, profile])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.success_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>
        {t('choose_aki_status.modal.success_description')}
      </ModalDescription>
      <ModalActions>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleGoToProfile}>
          {t('choose_aki_status.modal.my_profile')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
